import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { ItemPedido } from 'src/app/models/pedido';
import { CarregandoService } from 'src/app/services/carregando.service';
import { GlobalService } from 'src/app/services/global.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PremissasService } from 'src/app/services/premissas.service';

@Component({
  selector: 'app-detalhe-estrutura-modal',
  templateUrl: './detalhe-estrutura-modal.component.html',
  styleUrls: ['./detalhe-estrutura-modal.component.scss']
})
export class DetalheEstruturaModalComponent implements OnInit {
  public config: PerfectScrollbarConfigInterface = {};
  mostrarValores = false;
  integrador = false;
  constructor(public dialogRef: MatDialogRef<DetalheEstruturaModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
  private notificacaoService: NotificacaoService, private carregandoService: CarregandoService, private globalService: GlobalService, private premissasService: PremissasService) { }

  itens: ItemPedido[] = [];
  async ngOnInit() {
    this.integrador = await this.globalService.integrador();
    this.buscarVerPrecosProdutos();
    this.itens = this.data.itens;
  }

  fechar() {
    this.dialogRef.close();
  }

  buscarVerPrecosProdutos() {
    this.carregandoService.mostra('buscarVerPrecosProdutos');
    this.premissasService.consultarVerPrecoProdutos().subscribe(f => {
      this.mostrarValores = f.valor;
      this.carregandoService.esconde('buscarVerPrecosProdutos');
    }, (erro) => {
      this.carregandoService.esconde('buscarVerPrecosProdutos');
      this.notificacaoService.erro(erro);
    });
  }


}
